import { BRAND_LIST, CountryLanguageSwitcher, DistanceUnit } from 'typings'
import * as Typings from '../typings'

const EstoniaLocale: Typings.LocaleType = {
  IS_EU: true,
  REGION: Typings.RegionGroupNames.OTHER,
  CODE: 'EE',
  LANGUAGE_CODE: 'en',

  LONG_NAME: 'Estonia',
  SHORT_NAME: 'EE',

  DISPLAY_NAME: 'Estonia (English)',
  DISPLAY_COUNTRY: 'Estonia (English)',

  GEO_COORDINATES: {
    INITIAL_LATITUDE: 58.6464787,
    INITIAL_LONGITUDE: 22.2940396,
    INITIAL_ZOOM: 5,
    INITIAL_ZOOM_DETAILS_PAGE: 15,
  },

  AREAS: {
    '1': 'Harju County',
    '2': 'Hiiu County',
    '3': 'Ida-Viru County',
    '4': 'Jõgeva County',
    '5': 'Järva County',
    '6': 'Lääne County',
    '7': 'Lääne-Viru County',
    '8': 'Põlva County',
    '9': 'Pärnu County',
    '10': 'Rapla County',
    '11': 'Saare County',
    '12': 'Tartu County',
    '13': 'Valga County',
    '14': 'Viljandi County',
    '15': 'Võru County',
  },

  HOME_PAGE_URL: 'https://www.uniqlo.com/eu-ee/en/',

  MAP_MOBILE_URL: 'https://map.uniqlo.com/eu-ee/en/',

  CONTACT_US_URL: 'https://faq-eu.uniqlo.com/',
  TERMS_OF_USE_URL:
    'https://faq-eu.uniqlo.com/pkb_Home_UQ_EU?l=en&c=category_uq_eu_dk_se%3ARenew_UQEU_C7_3',
  PRIVACY_POLICY_URL:
    'https://faq-eu.uniqlo.com/pkb_Home_UQ_EU?l=dk&c=category_uq_eu_dk_se%3ARenew_UQEU_C7_2',

  POSTCODE_FORMAT: /^[0-9]{5}$/,

  CLIENT_ID: {
    [BRAND_LIST.UQ]: '',
  },

  DISTANCE_UNIT: DistanceUnit.KM,

  SHOW_COUNTRY_LANGUAGE_MODAL: {
    [BRAND_LIST.UQ]: CountryLanguageSwitcher.HEADER_SWITCHER_MODAL,
    [BRAND_LIST.GU]: CountryLanguageSwitcher.ALL_DISABLED,
    [BRAND_LIST.PL]: CountryLanguageSwitcher.ALL_DISABLED,
  },

  ONE_TRUST_FOOTER: {
    [BRAND_LIST.UQ]: true,
  },
}

export default EstoniaLocale
